import colors from "../colors/index";
export var defaultTheme = {
  baseIndent: 4,
  breakpoints: {
    xs: 320,
    sm: 768,
    md: 1024,
    lg: 1280
  },
  gridSize: 12,
  gutterWidth: 2,
  container: {
    indent: {
      xs: 4,
      sm: 4,
      md: 4,
      lg: 9
    },
    maxWidth: '1920px'
  },
  button: {
    borderRadius: {
      small: '3px',
      normal: '4px',
      large: '4px'
    },
    height: {
      small: 30,
      normal: 40,
      large: 50
    },
    padding: {
      small: '0 12px',
      normal: '0 16px',
      large: '0 24px'
    },
    bgColor: colors.lightGreyGreenThree,
    color: colors.darkBlueGreen,
    disabled: {
      bgColor: colors.paleGreyThree,
      color: colors.pinkishGrey
    },
    hover: {
      bgColor: colors.sageLight,
      borderColor: 'red'
    },
    active: {
      bgColor: colors.lightGreyGreenFour
    },
    focus: {
      bgColor: colors.lightGreyGreenThree
    },
    loading: {
      bgColor: colors.lightGreyGreenFour,
      color: 'green'
    },
    borderColor: 'blue'
  },
  typography: {
    100: {
      fontSize: '11px',
      lineHeight: '15px'
    },
    200: {
      fontSize: '12px',
      lineHeight: '16px'
    },
    300: {
      fontSize: '14px',
      lineHeight: '22px'
    },
    400: {
      fontSize: '16px',
      lineHeight: '28px'
    },
    500: {
      fontSize: '18px',
      lineHeight: '26px'
    },
    600: {
      fontSize: '24px',
      lineHeight: '28px'
    },
    700: {
      fontSize: '28px',
      lineHeight: '34px'
    },
    800: {
      fontSize: '34px',
      lineHeight: '40px'
    }
  },
  radioButton: {
    bgColor: 'white',
    borderColor: 'gray',
    dotColor: 'gray',
    checkedBgColor: 'white',
    checkedBorderColor: 'green',
    checkedDotColor: 'green',
    buttonSize: 16,
    dotSize: 8,
    disabledColor: 'lightgray'
  },
  checkBox: {
    bg: 'white',
    border: '#E6E6E6',
    checkedBg: '#F0F1F2',
    checkedBorder: '#F0F1F2',
    icon: '#004B46'
  },
  toggle: {
    bg: '#C8CACC',
    checkedBg: '#004b46',
    hoverBg: '#276460',
    disabledBg: '#E1E4E6',
    tapArea: 4
  },
  input: {
    borderRadius: {
      large: 4,
      normal: 4,
      small: 3
    },
    height: {
      "default": {
        large: 50,
        normal: 40,
        small: 30
      }
    },
    padding: {
      large: '0 16px',
      normal: '0 12px',
      small: 8
    },
    fontSize: {
      large: 400,
      normal: 300,
      small: 200
    },
    bgColor: '#F0F1F2',
    disabled: {
      color: '#cccccc',
      placeholderColor: '#cccccc'
    },
    error: {
      bgColor: '#F0F1F2',
      borderColor: '#FF6982'
    },
    addonWidth: 32,
    addonHeight: 'auto',
    focus: {
      bgColor: '#ffffff',
      shadow: '0 4px 12px 0 rgba(0, 0, 0, 0.05), 0 2px 6px 0 rgba(0, 0, 0, 0.05), 0 0 4px 0 rgba(0, 0, 0, 0.05)',
      placeholderColor: '#999999'
    },
    hover: {
      bgColor: '#e3e4e5'
    },
    transition: 'background-color 300ms ease-out',
    label: {
      color: '#999999',
      fontSize: {
        large: 400,
        normal: 300,
        small: 200
      }
    },
    errorText: {
      color: '#ffffff',
      bgColor: '#FF6982',
      fontSize: {
        large: 400,
        normal: 300,
        small: 200
      }
    },
    helperText: {
      color: '#999999'
    },
    placeholder: {
      color: '#999999',
      asteriskColor: '#ff3377'
    }
  },
  typographyMobile: {
    100: {
      fontSize: '10px',
      lineHeight: '15px'
    },
    200: {
      fontSize: '11px',
      lineHeight: '16px'
    },
    300: {
      fontSize: '11px',
      lineHeight: '16px'
    },
    400: {
      fontSize: '12px',
      lineHeight: '18px'
    },
    500: {
      fontSize: '13px',
      lineHeight: '20px'
    },
    600: {
      fontSize: '17px',
      lineHeight: '22px'
    },
    700: {
      fontSize: '22px',
      lineHeight: '26px'
    },
    800: {
      fontSize: '25px',
      lineHeight: '32px'
    }
  }
};
export var themeConfig = {
  breakpointNames: ['xs', 'sm', 'md', 'lg'],
  breakpointOffsetNames: ['xsOffset', 'smOffset', 'mdOffset', 'lgOffset', 'xlOffset']
};
export var Breakpoints;

(function (Breakpoints) {
  Breakpoints["xs"] = "xs";
  Breakpoints["sm"] = "sm";
  Breakpoints["md"] = "md";
  Breakpoints["lg"] = "lg";
})(Breakpoints || (Breakpoints = {}));

export var BreakpointsOffset;

(function (BreakpointsOffset) {
  BreakpointsOffset["xsOffset"] = "xsOffset";
  BreakpointsOffset["smOffset"] = "smOffset";
  BreakpointsOffset["mdOffset"] = "mdOffset";
  BreakpointsOffset["lgOffset"] = "lgOffset";
})(BreakpointsOffset || (BreakpointsOffset = {}));